/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Step_4Inputs */

const en_svc_integration_step_4 = /** @type {(inputs: Svc_Integration_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitor quality and cost after launch, and adjust as models change.`)
};

const lv_svc_integration_step_4 = /** @type {(inputs: Svc_Integration_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pēc ieviešanas uzraugām kvalitāti un izmaksas un pielāgojam, mainoties modeļiem.`)
};

/**
* | output |
* | --- |
* | "Monitor quality and cost after launch, and adjust as models change." |
*
* @param {Svc_Integration_Step_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_step_4 = /** @type {((inputs?: Svc_Integration_Step_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Step_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_step_4(inputs)
	return en_svc_integration_step_4(inputs)
});